import { render, staticRenderFns } from "./RefsTable.vue?vue&type=template&id=1b22cf84&scoped=true&"
import script from "./RefsTable.vue?vue&type=script&lang=js&"
export * from "./RefsTable.vue?vue&type=script&lang=js&"
import style0 from "./RefsTable.vue?vue&type=style&index=0&id=1b22cf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22cf84",
  null
  
)

export default component.exports